export default __webpack_public_path__ + "static/media/trace_teachers_button.20193215.svg";